import React from "react";
import { Link } from "react-router-dom";
import partnerTwoImgBox from "../../assets/images/resources/partener-two-img-box.png";
import partnerTwoImgBoxImg1 from "../../assets/images/resources/partner-two-info-img-1.png";
import partnerTwoImgBoxImg2 from "../../assets/images/resources/partner-two-info-img-2.png";
import partnerTwoImgBoxImg3 from "../../assets/images/resources/partner-two-info-img-3.png";
import partnerTwoImgBoxImg4 from "../../assets/images/resources/partner-two-info-img-4.png";
import partnerTwoImgBoxImg5 from "../../assets/images/resources/partner-two-info-img-5.png";
import partnerTwoImgBoxImg6 from "../../assets/images/resources/partner-two-info-img-6.png";
import partnerTwoImgBoxImg7 from "../../assets/images/resources/partner-two-info-img-7.png";
import partnerTwoImgBoxImg8 from "../../assets/images/resources/partner-two-info-img-8.png";
import partnerTwoImgBoxImg9 from "../../assets/images/resources/partner-two-info-img-9.png";

function Partner() {
  return (
    <div>
      <section className="partener-two">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-5 col-lg-12 col-md-12 col-sm-12">
              <div
                className="partener-two-img-box wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                <div className="partener-two-img">
                  <div className="scroll_item_select_img1">
                    <img
                      src={partnerTwoImgBox}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-7 col-lg-12 col-md-12 col-sm-12">
              <div className="partener-two-info-box">
                <div className="section-three-title">
                  <div
                    className="section-three-title-text wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                  >
                    <p>Global Partner</p>
                  </div>
                  <div
                    className="section-three-title-title wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="300ms"
                  >
                    <h2>
                      I’ve 1253+ Global Clients &amp;lot’s of Project Complete
                    </h2>
                  </div>
                </div>
                <div className="row align-items-center">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="100ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg1}
                          alt="partner-two-info-img-1"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="200ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg2}
                          alt="partner-two-info-img-2"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="300ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg3}
                          alt="partner-two-info-img-3"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="400ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg4}
                          alt="partner-two-info-img-4"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="500ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg5}
                          alt="partner-two-info-img-5"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="600ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg6}
                          alt="partner-two-info-img-6"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="700ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg7}
                          alt="partner-two-info-img-7"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="800ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg8}
                          alt="partner-two-info-img-8"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-6">
                    <div
                      className="partener-two-info-img wow fadeInRight animated"
                      data-wow-duration="1500ms"
                      data-wow-delay="900ms"
                    >
                      <Link to="#">
                        <img
                          src={partnerTwoImgBoxImg9}
                          alt="partner-two-info-img-9"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Partner;
